import React from "react";
import { Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../_metronic/layout";
import CGFeedback from "./CGFeedback";


export default function FeedbackPage() {
  const subheader = useSubheader();
  subheader.setTitle("Feedback");

  return (
    <div className="d-flex flex-row">
      <div className="flex-row-fluid">
        <Switch>
          {/* <Redirect from="/feedback" exact={true} to="/feedback" /> */}
          <Route path="/feedback" component={CGFeedback} />
        </Switch>
      </div>
    </div>
  );
}
